var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"map-controls-sidebar"}},[_c('sidebar-layers'),_c('sidebar-search'),_c('sidebar-own-vessel',{attrs:{"map":_vm.map}}),_c('sidebar-selected-vessel',{attrs:{"map":_vm.map}}),_c('sidebar-filter'),_c('sidebar-plot'),_c('sidebar-weather'),_c('sidebar-vehicle'),_c('sidebar-settings'),_c('floating-unit',{attrs:{"map":_vm.map}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }